module.exports = __webpack_public_path__ + "static/img/3.f286f07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/1/3.png
// module id = kvIH
// module chunks = 0